
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  AIGroup,
  Answer,
  Candidate,
  CandidateResult,
  FingerCheckResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];
const errorEnumTextEX = {
  bgCheckIdentity: ["手机号实名未查询", "手机号实名异常", "通过"],
  bgCheckFinancial: ["综合B类评估未检测", "综合B类评估异常", "通过"],
  bgCheckSocial: ["综合A类评估未检测", "综合A类评估异常", "通过"],
  faceCheck: ["样本数量不足无法检测", "人脸核验异常", "通过"],
  replacePerson: ["样本数量不足无法检测", "换人检测异常", "通过"],
  faceDetection: ["样本数量不足无法检测", "露脸检测异常", "通过"],
  webJump: ["未进行防切屏检测", "切屏异常", "通过"],
  screenshot: ["未进行防截屏检测", "截屏异常", "通过"],
  mobileJoinCount: ["未进行防切屏检测", "切屏异常", "通过"]
};
const errorEnumName = {
  bgCheckIdentity: "手机号实名认证",
  bgCheckFinancial: "综合B类评估记录",
  bgCheckSocial: "综合A类评估记录",
  screenshot: "候选人防截屏",
  mobileJoinCount: "候选人防切屏",
  replacePerson: "换人检测",
  // webJump: "Web防切屏检测",
  faceDetection: "露脸检测",
  faceCheck: "人脸核验"
};
//手部
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}

@Component({})
export default class PaperResultReport extends Vue {
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: "" }) connectCode!: string;
  @Prop() index!: number;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  //是否分组展示
  public get isGroup() {
    return this.all.configGroup.showType === 1;
  }
  //模块展示
  public Show(p: string) {
    return this.all.reportShowConfig?.[p] !== 1;
  }

  get mindData() {
    return this.all?.questionAnswerMap?.[106]?.[0]?.answer ?? new Answer();
  }
  // 心理健康等级
  get minDataLevel() {
    const score = this.mindData.psycResult.newResultList[0]?.isMatch;
    if (score === 2) {
      return {
        text: "高风险",
        color: "#F72D20"
      };
    } else if (score === 1) {
      return {
        text: "中风险",
        color: "#FF9B00"
      };
    } else if (score === 0) {
      return {
        text: "低风险",
        color: "#19C976 "
      };
    } else {
      return {};
    }
  }
  //手指检测109
  get finger() {
    return (
      this.all?.questionAnswerMap?.[109]?.[0]?.answer?.fingerCheckResult ||
      new FingerCheckResult()
    );
  }
  get colorAnswer() {
    return (
      this.all.answerList.find(item => item.type === 102) ||
      ({ isAnswered: 0, type: 0, blindnessResult: 0, weaknessResult: 0 } as any)
    );
  }
  get gameQi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  get tag() {
    if (this.gameQi.balloonData.cognitiveAbilityScore <= 4) {
      return "较低";
    } else if (this.gameQi.balloonData.cognitiveAbilityScore >= 6) {
      return "较高";
    } else return "正常";
  }
  // 其他
  get other() {
    return this.gameQi.balloonData.cognitiveAbilityScore >= 8;
  }

  // 类普工版要求这些考察项结果在此按照配置顺序罗列出来
  workVersionShowTestName = [
    "手部综合检测",
    "辩色检测",
    "背景调查",
    "游戏测评打气球",
    "维度分析",
    "DVF1.0心理风险测量",
    "作弊风险检测"
  ];
  workSortTestList: {
    name: string;
    result: number;
    content: string;
    text: string;
    color: string;
    iconRevert?: number;
    showRession?: boolean;
  }[] = [];

  groupLogo =
    "https://oss.hina.com/app/hina/2023/06/25/1aa4eff607c642b6c6aba3b4d16baedc.svg"; //兜底图标

  created() {
    //
    if (this.option.versionId === 1) {
      this.all.reportShowConfigV5.forEach(item => {
        if (this.workVersionShowTestName.includes(item.name)) {
          this.addWorkTestList(item.name);
        }
      });
    }
  }

  //
  mounted() {
    //
    this.getStarFloat();
  }

  fingerResText(i: number) {
    if (this.all.questionAnswerMap[109][0]?.answer.isAnswered !== 1) {
      return "候选人未作答";
    }
    return enumFinger[i];
  }

  getColorText() {
    if (this.colorAnswer.colorQuestionAnswerResult.blindnessResult === 2) {
      return "色盲";
    } else if (
      this.colorAnswer.colorQuestionAnswerResult.weaknessResult === 2
    ) {
      return "色弱";
    } else {
      return "";
    }
  }

  addWorkTestList(name: string) {
    const fingerIsAnswerd =
      this.all.questionAnswerMap[109][0]?.answer.isAnswered === 1;
    const colorIsAnswerd = this.colorAnswer.isAnswered === 1;
    switch (name) {
      case "手部综合检测":
        if (this.all.questionAnswerMap[109][0]) {
          if (this.finger.resultComplete !== 255) {
            this.workSortTestList.push({
              name: "手部完整度",
              result: this.finger.resultComplete,
              content: this.fingerResText(this.finger.resultComplete),
              color: !fingerIsAnswerd
                ? "yellow"
                : this.finger.resultComplete === 1
                ? "green"
                : this.finger.resultComplete === 2
                ? "red"
                : "yellow",
              text: !fingerIsAnswerd
                ? "未检测"
                : this.getText(this.finger.resultComplete)
            });
          }
          if (this.finger.resultFlexible !== 255) {
            this.workSortTestList.push({
              name: "灵活度检测",
              result: this.finger.resultFlexible,
              content: this.fingerResText(this.finger.resultFlexible),
              color: !fingerIsAnswerd
                ? "yellow"
                : this.finger.resultFlexible === 1
                ? "green"
                : this.finger.resultFlexible === 2
                ? "red"
                : "yellow",
              text: !fingerIsAnswerd
                ? "未检测"
                : this.getText(this.finger.resultFlexible)
            });
          }
          if (this.finger.resultScar !== 255) {
            this.workSortTestList.push({
              name: "疤痕与纹身",
              result: this.finger.resultScar,
              content: this.fingerResText(this.finger.resultScar),
              color: !fingerIsAnswerd
                ? "yellow"
                : this.finger.resultScar === 1
                ? "green"
                : this.finger.resultScar === 2
                ? "red"
                : "yellow",
              text: !fingerIsAnswerd
                ? "未检测"
                : this.getText(this.finger.resultScar)
            });
          }
        }
        break;
      case "辩色检测":
        this.all.errorInfoList.forEach(item => {
          if (item.task === "eyeColor") {
            this.workSortTestList.push({
              color: !colorIsAnswerd
                ? "yellow"
                : item.result === 1
                ? "red"
                : item.result === 0
                ? "yellow"
                : "green",
              result: item.result,
              name: "辨色检测",
              content: !colorIsAnswerd
                ? "候选人未作答"
                : this.getColorText() || errorEnumText[item.result],
              text: !colorIsAnswerd
                ? "未检测"
                : this.getColorText() || errorEnumText[item.result],
              iconRevert: this.errorIconRevert(item.result)
            });
          }
        });
        break;
      case "背景调查":
        this.all.errorInfoList.forEach(item => {
          if (
            ["bgCheckIdentity", "bgCheckFinancial", "bgCheckSocial"].includes(
              item.task
            )
          ) {
            this.workSortTestList.push({
              color:
                item.result === 1
                  ? "red"
                  : item.result === 0
                  ? "yellow"
                  : "green",
              result: item.result,
              name: errorEnumName[item.task],
              content:
                item.resMessage ||
                errorEnumTextEX?.[item.task]?.[item.result] ||
                errorEnumText[item.result],
              text: errorEnumText[item.result],
              iconRevert: this.errorIconRevert(item.result),
              showRession: item.result === 1 && item.task !== "bgCheckIdentity"
            });
          }
        });
        break;
      case "游戏测评打气球":
        if (
          this.all?.questionAnswerMap?.[107][0] &&
          this.gameQi.gameIsFinish === 1
        ) {
          this.workSortTestList.push({
            color: "green",
            result: 1,
            name: "打气球游戏测评",
            content: "",
            text:
              "认知" +
              this.tag +
              (this.other
                ? ""
                : " | " + this.gameQi.balloonData.riskAppetiteType)
          });
        } else if (
          this.all.questionAnswerMap[107][0] &&
          this.all.questionAnswerMap[107][0]?.answer?.isAnswered !== 1
        ) {
          this.workSortTestList.push({
            color: "yellow",
            result: 0,
            name: "打气球游戏测评",
            content: "",
            text: "未作答"
          });
        }
        break;
      case "维度分析":
        this.all.dimensionReport.forEach(item => {
          this.workSortTestList.push({
            color:
              // item.unanswered === 1
              //   ? "yellow"
              //   :
              item.dimensionLevel === 10 ? "red" : "green",
            result: 0,
            name: item.dimension,
            content: "",
            text:
              // item.unanswered === 1 ? "未作答" :
              item.dimensionLevelDesc,
            iconRevert:
              // item.unanswered === 1 ? 0 :
              item.dimensionLevel === 10 ? 2 : 1
          });
        });
        break;
      case "DVF1.0心理风险测量":
        if (this.mindData.psycResult.psycGaugeId === 5) {
          this.workSortTestList.push({
            color:
              this.mindData.isAnswered !== 1
                ? "yellow"
                : this.minDataLevel.text === "高风险"
                ? "red"
                : "green",
            result: 0,
            name: "DVF1.0心理健康测量",
            content: "",
            text:
              this.mindData.isAnswered !== 1
                ? "未作答"
                : this.minDataLevel.text || "",
            iconRevert:
              this.mindData.isAnswered !== 1
                ? 0
                : this.minDataLevel.text === "高风险"
                ? 2
                : 1
          });
        }
        break;
      case "作弊风险检测":
        this.all.errorInfoList.forEach(item => {
          if (
            [
              "screenshot",
              "mobileJoinCount",
              "replacePerson",
              // "webJump",
              "faceDetection",
              "faceCheck"
            ].includes(item.task)
          ) {
            this.workSortTestList.push({
              color:
                item.result === 1
                  ? "red"
                  : item.result === 0
                  ? "yellow"
                  : "green",
              result: item.result,
              name: errorEnumName[item.task],
              content:
                item.resMessage ||
                errorEnumTextEX?.[item.task]?.[item.result] ||
                errorEnumText[item.result],
              text: errorEnumText[item.result],
              iconRevert: this.errorIconRevert(item.result)
            });
          }
        });
        break;
    }
  }

  errorIconRevert(result: number) {
    return {
      0: 0,
      1: 2,
      2: 1
    }[result];
  }

  getIconFontClassMap = {
    0: "&#xe6c0;", // yellow
    1: "&#xe6cc;", // green
    2: "&#xe6bf;" // red
  };

  getText(i: number) {
    return ["未检测", "通过", "未通过"][i];
  }

  //无级变速星星
  getStarFloat() {
    setTimeout(() => {
      this.all.dimensionReportGroup.forEach((dim: AIGroup, index: number) => {
        const score = Number(dim.starLevel.toFixed(2)); //0 - 5  取两位小数
        const empty = 5 - Math.ceil(score); //空星星个数
        const full = Math.floor(score); //满星星个数
        const half = 5 - empty - full; //半星星个数
        const haflStar = this.$refs[`dim${index}star${full}left`]; //哪个是半颗星星
        if (full) {
          for (let i = 0; i < full; i++) {
            const star = this.$refs[`dim${index}star${i}left`];
            if (star?.[0]?.style) {
              star[0].style.width = "100%";
            }
          }
        }
        if (empty) {
          for (let i = 0; i < empty; i++) {
            const star = this.$refs[`dim${index}star${i + half + full}left`];
            if (star?.[0]?.style) {
              star[0].style.width = "0%";
            }
          }
        }
        if (half && haflStar?.[0]?.style) {
          haflStar[0].style.width = `${(score - full) * 100}%`; //calc(${(score - full) * 100}%)
        }
        // console.log(index, score, empty, full, score - full);
      });
    }, 0);
  }
}
